<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
   <ion-fab vertical="bottom" horizontal="end" slot="fixed" *ngIf="pwa.canPromptInstall">
    <ion-fab-button (click)="pwa.promptInstall()">
      <ion-icon name="download-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-app>



